import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.number()
})

export type HealthScoreAssetDashboard = z.infer<typeof ZApiResponse>

export async function getTotalHealthScoreAssetDashboard (
  siteId: string,
  assetIds: string,
  onSuccess: (HealthScoreAssetDashboard: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/alarm-service/api/v1/udp/tiq/assets/alerts/healthScore?siteId=${siteId}&assetId=${assetIds}`
  interceptedAxios
    .get(url, { timeout: 10000 })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
